import { FC } from 'react';
import { isArray, isEmpty, take } from 'lodash';
import { faLandmark } from '@fortawesome/free-solid-svg-icons';

import { useFeatureFlag } from '@app/hooks';
import { NavigationDropdownItem } from '@app/translations';
import { Feature } from '@app/constants';

import {
  NavigationDropdown,
  NavigationDropdownProps,
} from '../NavigationDropdown';

interface LibraryResourcesDropdownProps {
  commonNavigationDropdownProps: Partial<NavigationDropdownProps>;
}

const maxAmountOfLinksToDisplay = 5;

export const LibraryResourcesDropdown: FC<LibraryResourcesDropdownProps> = ({
  commonNavigationDropdownProps,
}) => {
  const { isActive: isLibraryResourcesFlagActive, config } = useFeatureFlag({
    name: Feature.libraryResources,
  });

  if (!isLibraryResourcesFlagActive || !isArray(config)) {
    return null;
  }

  const libraryResourcesLinks = take(
    config.filter(({ label, href }) => label && href),
    maxAmountOfLinksToDisplay
  );

  if (isEmpty(libraryResourcesLinks)) {
    return null;
  }

  return (
    <NavigationDropdown
      name={NavigationDropdownItem.libraryResources}
      icon={faLandmark}
      links={libraryResourcesLinks}
      {...commonNavigationDropdownProps}
    />
  );
};
